import { render, staticRenderFns } from "./pagetitle.vue?vue&type=template&id=e4a7793c&scoped=true&"
import script from "./pagetitle.vue?vue&type=script&lang=js&"
export * from "./pagetitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a7793c",
  null
  
)

export default component.exports